<template>
  <div class="display one-component-detail-admin">
    <div class="title-component-admin">Số sao - Hạng phòng</div>
    <el-form :model="data" class="p-3">
      <el-rate
        :value="Number(data.star) || 0"
        :max="6"
        text-color="#ff9900"
        @change="(val) => (data.star = val)"
      />
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Star',
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped></style>
